'use strict';

var HelpButtonDirective = function HelpButtonDirective($window, helpPageUrlService) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/help-button.html'),
    scope: {
      page: '@'
    },
    link: function link($scope, element) {
      element.on('click', function () {
        var url = helpPageUrlService.getUrl($scope.page);
        $window.open(url);
      });
    }
  };
};
HelpButtonDirective.$inject = ['$window', 'HelpPageUrlService'];
module.exports = HelpButtonDirective;